// extracted by mini-css-extract-plugin
export var button = "ConnectGoogle-module__button___OCmLQ";
export var disabled = "ConnectGoogle-module__disabled___dBNFL";
export var loading = "ConnectGoogle-module__loading___Ses_R";